import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  Avatar,
  Button,
  Chip,
  Alert,
} from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import MaleIcon from '@mui/icons-material/Male';
import FemaleIcon from '@mui/icons-material/Female';
import OpacityIcon from '@mui/icons-material/Opacity';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';
import api from '../../services/api';

// ... import statements تبقى كما هي

const OwnerHorsesList = () => {
  const { t, i18n } = useTranslation();
  const { ownerId } = useParams();
  const navigate = useNavigate();
  const theme = useTheme();

  const [horses, setHorses] = useState([]);
  const [error, setError] = useState('');

  const getColorIcon = (color) => {
    const upperColor = color?.toUpperCase();
    return (
      theme.palette.horseColors[upperColor] || theme.palette.horseColors.DEFAULT
    );
  };

  const getStats = (horsesList) => {
    return {
      total: horsesList.length,
      males: horsesList.filter((h) => h.gender === 'S').length,
      females: horsesList.filter((h) => h.gender === 'M').length,
    };
  };

  useEffect(() => {
    api
      .get(`/owners/${ownerId}/horses-with-details`)
      .then((res) => setHorses(res.data))
      .catch((err) => {
        console.error('Error fetching horses:', err);
        setError(t('error_fetching_horses'));
      });
  }, [ownerId, t]);

  const stats = getStats(horses);

  return (
    <Container maxWidth="lg" dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
      <Box sx={{ mt: 4 }}>
        {error && <Alert severity="error">{error}</Alert>}

        <Typography variant="h4" align="center" gutterBottom>
          {t('owner_horses_list')}
        </Typography>

        {/* إحصائيات */}
        <Box
          display="flex"
          justifyContent="center"
          gap={3}
          flexWrap="wrap"
          mb={4}
        >
          <Chip
            label={`${t('total_horses')}: ${stats.total}`}
            color="primary"
          />
          <Chip label={`${t('stallions')}: ${stats.males}`} color="info" />
          <Chip label={`${t('mares')}: ${stats.females}`} color="secondary" />
        </Box>

        <Grid container spacing={3}>
          {horses.map((horse) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={horse.horse_id}>
              <Card
                elevation={3}
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  p: 2,
                  textAlign: 'center',
                }}
              >
                <Avatar
                  src={horse.image_url}
                  alt={horse.name}
                  sx={{ width: 80, height: 80, mx: 'auto', mb: 1 }}
                >
                  {(horse.name || horse.name_arabic || '-').charAt(0)}
                </Avatar>
                <CardContent sx={{ p: 1 }}>
                  <Typography variant="h6">
                    {i18n.language === 'ar' ? horse.name_arabic : horse.name}
                  </Typography>

                  <Chip
                    icon={
                      horse.gender === 'S' ? (
                        <MaleIcon color="primary" />
                      ) : (
                        <FemaleIcon color="secondary" />
                      )
                    }
                    label={
                      i18n.language === 'ar'
                        ? horse.gender === 'S'
                          ? 'حصان'
                          : 'فرس'
                        : horse.gender === 'S'
                        ? 'Stallion'
                        : 'Mare'
                    }
                    sx={{ mt: 1, mx: 0.5 }}
                  />

                  <Chip
                    avatar={
                      <Avatar
                        sx={{
                          bgcolor: getColorIcon(horse.color_english),
                          width: 22,
                          height: 22,
                        }}
                      >
                        <OpacityIcon htmlColor="#fff" />
                      </Avatar>
                    }
                    label={
                      i18n.language === 'ar'
                        ? horse.color_arabic
                        : horse.color_english
                    }
                    sx={{ mt: 1, mx: 0.5 }}
                  />

                  <Chip
                    icon={<HomeIcon color="info" />}
                    label={
                      horse.stable_name && horse.room_name
                        ? `${horse.stable_name} - ${horse.room_name}`
                        : t('room_name_not_available')
                    }
                    sx={{ mt: 1 }}
                  />
                </CardContent>

                <Box pb={2}>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() =>
                      navigate(`/horse-details-client/${horse.horse_id}`)
                    }
                  >
                    {t('view_details')}
                  </Button>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
};

export default OwnerHorsesList;
